<script setup lang="ts">
import {ConfigProvider as AConfigProvider, StyleProvider as AStyleProvider} from "ant-design-vue";
import {legacyLogicalPropertiesTransformer} from 'ant-design-vue';
import {message} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import ApiErrorsModal from "shared/components/ApiErrorsModal.vue";

const [, contextHolder] = message.useMessage();
dayjs.locale('cn');

</script>

<template>
    <a-config-provider
        :locale="zhCN"
        :theme="{
          token: {
            // colorPrimary: '#21cc98',
          },
        }"
    >
        <a-style-provider hash-priority="high" :transformers="[legacyLogicalPropertiesTransformer]">
            <contextHolder />
            <router-view/>
            <api-errors-modal />
        </a-style-provider>
    </a-config-provider>
</template>